import FetchHelpers from 'utils/FetchHelpers';
import { apiRoutes } from 'routes';

export default {
  create(attrs) {
    const url = apiRoutes.saveProfileImagePath();

    return FetchHelpers.post(url, attrs);
  },
};



// WEBPACK FOOTER //
// ./src/repositories/ProfileImageRepository.js